export const onlySpacesRegex = /^\s*$/;
export const httpsLinkRegex = /^(http[s?]?:\/\/).*/;
